export const SET_SECONDARY_SEARCH = 'SET_SECONDARY_SEARCH';
export const CLEAR_SECONDARY_SEARCH = 'CLEAR_SECONDARY_SEARCH';
export const CLEAR_ALL_SECONDARY_SEARCH = 'CLEAR_ALL_SECONDARY_SEARCH';
